<template>
  <CModal
    class="modal__footer-empty"
    title="Edit comment"
    centered
    :show="show"
    @update:show="closeModal"
  >
    <VCommentForm
      v-if="showForm"
      :comment="comment"
      @success="onSuccess"
    />
  </CModal>
</template>
<script>
import VCommentForm from '@/components/Forms/VCommentForm'
import { modalStore } from '@/mixins/modalsMixin'

export default {
  name: 'TheCommentModal',

  components: {
    VCommentForm
  },

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    showForm: true
  }),

  computed: {
    comment () {
      return this.$store.getters[`${modalStore.moduleName}/${modalStore.getterTypes.GETTER_MODAL_CONTENTS}`]
    }
  },

  methods: {
    closeModal () {
      this.$store.dispatch(`${modalStore.moduleName}/${modalStore.actionTypes.ACTION_SET_MODAL_CONTENTS}`, null)
      this.$emit('close')
    },

    onSuccess () {
      this.closeModal()
    }
  }
}
</script>
